import PropTypes from 'prop-types';
import React, {Component} from 'react';
import style from './style.css';
import ElementTooltipContainer from "~/components/Tooltip/ElementTooltipContainer";
import { Dropdown, HStack, Text } from "~/native-ui"

const dropdownValues = [
    { value: 1, label: '1' },
    { value: 5, label: '5' },
    { value: 10, label: '10' },
    { value: 15, label: '15' },
    { value: 20, label: '20' },
    { value: 50, label: '50' },
    { value: 100, label: '100' },
];

export default class PerPageSwitch extends Component {
    static propTypes = {
        currentPage: PropTypes.number.isRequired,
        total: PropTypes.number.isRequired,
        perPage: PropTypes.number.isRequired,
        onPerPageChange: PropTypes.func.isRequired,
        trans: PropTypes.func.isRequired,
    };

    render() {
        let { trans } = this.props;

        let first = Math.max((this.props.currentPage-1), 0) * this.props.perPage + 1,
            last = Math.min(this.props.currentPage * this.props.perPage, this.props.total);

        return (
            <HStack space={2} alignItems="center">
                {this.props.onPerPageChange ? <ElementTooltipContainer leftMargin className={style.dropdownHolder} tooltip={this.props.tooltip}>
                    <Dropdown
                        valueKey="value"
                        labelKey="label"
                        allowBlank={false}
                        value={this.props.perPage}
                        source={dropdownValues}
                        onChange={this.props.onPerPageChange}
                    />
                </ElementTooltipContainer> : null}
                
                <Text>
                    {trans('showing')} {trans('entry')} {`${first} ${trans('toSmall')} ${last} `}
                    {trans('of')} {this.props.total} {trans('entries')}
                </Text>
            </HStack>
        );
    }
}